import styled from "styled-components";
import device from "src/styles/device";
import Main from "src/components/ui/Container";

const Container = styled.div`
  width: 100%;
  height: 100%;
  /* max-width: 1440px; */
  padding: 60px 24px;
  background-color: #ffffff;
  display: ${(props) => (props.show ? "none" : "block")};

  @media ${device.tabletL} {
    padding: 24px 12px;
  }
  @media ${device.mobileL} {
    padding: 24px 0;
  }
`;

const WrapperContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const WrapperImg = styled.div`
  width: 100%;
  max-width: 1240px;

  @media ${device.desktopL} {
    max-width: 1000px;
  }
  @media ${device.desktop} {
    max-width: 800px;
  }
`;

const Img = styled.img`
  width: 100%;
  object-fit: cover;
`;

const Forbidden = ({ open }) => {
  return (
    <Main open={open}>
      <Container>
        <WrapperContent>
          <WrapperImg>
            <Img src="https://xsurface-images.s3.ap-southeast-1.amazonaws.com/403X10.png" />
          </WrapperImg>
        </WrapperContent>
      </Container>
    </Main>
  );
};

export default Forbidden;
